import { useCallback, useEffect, useReducer } from "react";

export type ActionType = {
  type: "SHARED" | "ERROR" | "RESET";
};

export type StateType = {
  shared: boolean;
  error: boolean;
};

const initialState: StateType = { shared: false, error: false };

export function reducer(state: StateType, action: ActionType): StateType {
  switch (action.type) {
    case "SHARED":
      return { ...state, shared: !state.shared };
    case "ERROR":
      return { ...state, error: true };
    case "RESET":
      return { ...state, error: false, shared: false };
    default:
      throw new Error("Unsupported action type");
  }
}

export function useLinkCopiedNotification() {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (state.shared) {
      const timer = setTimeout(() => {
        dispatch({ type: "RESET" });
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [state.shared]);

  const notify = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      dispatch({ type: "SHARED" });
    } catch {
      dispatch({ type: "ERROR" });
    }
  }, []);

  return {
    isError: state.error,
    showNotification: state.shared,
    notify,
  };
}
